import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import Form from 'components/Admin/ReportTemplates/Pages/Run/Form';
import WaitReport from 'components/Admin/ReportTemplates/Pages/Run/WaitReport';

export default function Run({ enterpriseId, onHide }) {
  const [reportData, setReportData] = useState(null);

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Generate Report
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {reportData ? (
          <WaitReport
            reportData={reportData}
            closeForm={onHide}
          />
        ) : (
          <Form
            enterpriseId={enterpriseId}
            setReportData={setReportData}
            closeForm={onHide}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
